import React, { createContext, useReducer } from "react";
import ToadReducer from "./reducers/ToadsReducers";

export const ToadsContext = createContext();

export const ToadsProvider = ({ children }) => {
  const initialState = { notify: {}, auth: {} };
  const [state, dispatch] = useReducer(ToadReducer, initialState);

  return (
    <ToadsContext.Provider value={[state, dispatch]}>
      {children}
    </ToadsContext.Provider>
  );
};
